<template>
  <li
    @mouseenter="hoverItem"
    @click="selectOptionClick($event)"
    class="el-select-dropdown__item"
    v-show="visible"
    :class="{
      'selected': itemSelected,
      'is-disabled': disabled || groupDisabled || limitReached,
      'hover': hover
    }">
    <slot>
      <span>{{ currentLabel }}</span>
    </slot>
  </li>
</template>

<script type="text/babel">
  import Emitter from 'element-ui/src/mixins/emitter';
  import { getValueByPath } from 'element-ui/src/utils/util';
  import Slip from 'slipjs';

  export default {
    mixins: [Emitter],

    name: 'ElOption',

    componentName: 'ElOption',

    inject: ['select'],

    props: {
      value: {
        required: true
      },
      index: {
        required: true,
        type: Number
      },
      size: {
        required: true,
        type: Number
      },
      label: [String, Number],
      created: Boolean,
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        // index: -1,
        groupDisabled: false,
        visible: true,
        hitState: false,
        hover: false
      };
    },

    computed: {
      isObject() {
        return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
      },

      currentLabel() {
        return this.label || (this.isObject ? '' : this.value);
      },

      currentValue() {
        return this.value || this.label || '';
      },

      itemSelected() {
        if (!this.select.multiple) {
          return this.isEqual(this.value, this.select.value);
        } else {
          return this.contains(this.select.value, this.value);
        }
      },

      limitReached() {
        if (this.select.multiple) {
          return !this.itemSelected &&
            (this.select.value || []).length >= this.select.multipleLimit &&
            this.select.multipleLimit > 0;
        } else {
          return false;
        }
      }
    },

    watch: {
      currentLabel() {
        if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
      },
      value() {
        if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
      }
    },

    methods: {
      isEqual(a, b) {
        if (!this.isObject) {
          return a === b;
        } else {
          const valueKey = this.select.valueKey;
          return getValueByPath(a, valueKey) === getValueByPath(b, valueKey);
        }
      },

      contains(arr = [], target) {
        if (!this.isObject) {
          return arr.indexOf(target) > -1;
        } else {
          const valueKey = this.select.valueKey;
          return arr.some(item => {
            return getValueByPath(item, valueKey) === getValueByPath(target, valueKey);
          });
        }
      },

      handleGroupDisabled(val) {
        this.groupDisabled = val;
      },

      hoverItem() {
        if (!this.disabled && !this.groupDisabled) {
          this.select.hoverIndex = this.select.options.indexOf(this);
        }
      },

      selectOptionClick(event) {
        if (event.target.classList.contains('prevent-close')) {
            event.target.classList.remove('prevent-close');
            return;
        }
        if (this.disabled !== true && this.groupDisabled !== true) {
          event.preventDefault();
          this.dispatch('ElSelect', 'handleOptionClick', this);
        }
      },

      queryChange(query) {
        // query 里如果有正则中的特殊字符，需要先将这些字符转义
        let parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
        this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
        if (!this.visible) {
          this.select.filteredOptionsCount--;
        }
      },

      getOrderWithIds () {

          const items = this.$parent.$el.getElementsByTagName('ul')[0].getElementsByTagName('li');

          const order = [];

          for (let i = 0; i < items.length; i++) {

            order.push({id: items[i].__vue__.$vnode.key, order: items[i].__vue__.order});

          }

          return order;

      },

    },

    created() {
      this.select.options.push(this);
      this.select.cachedOptions.push(this);
      this.select.optionsCount++;
      this.select.filteredOptionsCount++;

      this.$on('queryChange', this.queryChange);
      this.$on('handleGroupDisabled', this.handleGroupDisabled);
    },

    mounted() {

      this.order = this.index + 1;

      if (this.index + 1 === this.size) {

          const list = this.$parent.$el.getElementsByTagName('ul')[0];
          let resizer;

          new Slip(list);

          list.addEventListener('slip:beforereorder', function(e) {

            if (e.target.classList.contains('resize-triggers')) {

                e.preventDefault();

            } else {

                const el = list.getElementsByTagName('div')[0];

                if (el) {

                    resizer = el.cloneNode(true);

                    el.remove();

                }

                e.target.classList.add('prevent-close');

                e.target.parentElement.classList.add('prevent-close');

            }

          });

          list.addEventListener('slip:reorder', function(e) {

            e.target.parentNode.insertBefore(e.target, e.detail.insertBefore);

            if (resizer) {

                list.insertBefore(resizer, list.childNodes[0]);

            }

            const items = e.target.parentNode.getElementsByTagName('li');

            for (let i = 0; i < items.length; i++) {

                items[i].__vue__.order = i + 1;

            }

            this.$emit('reorder', this.getOrderWithIds());

          }.bind(this));

          list.addEventListener('slip:beforeswipe', function(e) {

            e.preventDefault();

          });

      }

    },

    beforeDestroy() {
      this.select.onOptionDestroy(this.select.options.indexOf(this));
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/sortable/SortableOption.vue